import {
  BarChart2, Sun, ListTodo, Columns, GanttChart,
  Target, CalendarDays, Link, BookOpen, StickyNote, Timer, AlertCircle, PieChart,
  BrainCircuit, Trophy, type LucideIcon,
} from 'lucide-react'
import { WidgetType } from '../../types'
import { lazy, type ComponentType } from 'react'

// Import widget content components
const StatsWidget = lazy(() => import('../Dashboard/StatsWidget'))
const CompletionChart = lazy(() => import('../Dashboard/CompletionChart'))
const TodayTasks = lazy(() => import('../Dashboard/TodayTasks'))
const OverdueWidget = lazy(() => import('../Dashboard/OverdueWidget'))
const DistributionWidget = lazy(() => import('../Dashboard/DistributionWidget'))
const TaskList = lazy(() => import('../Tasks/TaskList'))
const KanbanBoard = lazy(() => import('../Kanban/KanbanBoard'))
const GanttView = lazy(() => import('../Gantt/GanttView'))
const PriorityEffortMatrix = lazy(() => import('../Charts/PriorityEffortMatrix'))
const DayPlanner = lazy(() => import('../DayPlanner/DayPlanner'))
const LinksPage = lazy(() => import('../Links/LinksPage'))
const DiaryPage = lazy(() => import('../Diary/DiaryPage'))
const NotesPage = lazy(() => import('../Notes/NotesPage'))
const PomodoroWidget = lazy(() => import('../Pomodoro/PomodoroWidget'))
const ProgressPage = lazy(() => import('../Progress/ProgressPage'))
const TaskGraphPage = lazy(() => import('../Graph/TaskGraphPage'))

export interface WidgetMeta {
  type: WidgetType
  label: string
  color: string
  Icon: LucideIcon
  Component: ComponentType
}

export const WIDGET_REGISTRY: WidgetMeta[] = [
  { type: 'stats', label: 'Estatísticas', color: 'bg-blue-600', Icon: BarChart2, Component: StatsWidget },
  { type: 'completion-chart', label: 'Conclusão', color: 'bg-green-600', Icon: PieChart, Component: CompletionChart },
  { type: 'today-tasks', label: 'Hoje', color: 'bg-amber-500', Icon: Sun, Component: TodayTasks },
  { type: 'overdue', label: 'Atrasadas', color: 'bg-red-500', Icon: AlertCircle, Component: OverdueWidget },
  { type: 'distribution', label: 'Distribuição', color: 'bg-slate-600', Icon: BarChart2, Component: DistributionWidget },
  { type: 'task-list', label: 'Tarefas', color: 'bg-indigo-600', Icon: ListTodo, Component: TaskList },
  { type: 'kanban', label: 'Kanban', color: 'bg-violet-600', Icon: Columns, Component: KanbanBoard },
  { type: 'gantt', label: 'Gantt', color: 'bg-teal-600', Icon: GanttChart, Component: GanttView },
  { type: 'priority-matrix', label: 'Prioridade', color: 'bg-orange-600', Icon: Target, Component: PriorityEffortMatrix },
  { type: 'day-planner', label: 'Planejar Dia', color: 'bg-pink-600', Icon: CalendarDays, Component: DayPlanner },
  { type: 'links', label: 'Links', color: 'bg-cyan-600', Icon: Link, Component: LinksPage },
  { type: 'diary', label: 'Diário', color: 'bg-rose-600', Icon: BookOpen, Component: DiaryPage },
  { type: 'notes', label: 'Notas', color: 'bg-yellow-500', Icon: StickyNote, Component: NotesPage },
  { type: 'pomodoro', label: 'Pomodoro', color: 'bg-red-600', Icon: Timer, Component: PomodoroWidget },
  { type: 'progress', label: 'Progresso RPG', color: 'bg-amber-600', Icon: Trophy, Component: ProgressPage },
  { type: 'task-graph', label: 'Second Brain', color: 'bg-violet-600', Icon: BrainCircuit, Component: TaskGraphPage },
]

export const widgetByType = Object.fromEntries(
  WIDGET_REGISTRY.map((w) => [w.type, w])
) as Record<WidgetType, WidgetMeta>
